export default __webpack_public_path__ + "static/media/BA.a564b4ae.svg";